<div 
  class="vertical-menu bg-maltia"
  style="overflow-y: auto;">
  <div id="sidebar-menu" class="container-fluid">
    
    <div 
      *ngFor="let item of menuItems"
      class="row">

      <app-sidebar-item
        [menuItem]="item">
      </app-sidebar-item>

      <!-- <li class="menu-title" *ngIf="item.isTitle">{{ item.label | translate }}</li>

      <li *ngIf="!item.isTitle && !item.isLayout && hasPermission(item)">
        <a *ngIf="hasItems(item)" class="is-parent"
          [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
          <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
          <span class="text-white"> {{ item.label | translate }}</span>
          <span class="badge rounded-pill float-end bg-{{item.badge.variant}}" *ngIf="item.badge">{{item.badge.text |
            translate}}</span>
        </a>

        <a [routerLink]="item.link" *ngIf="!hasItems(item) && hasPermission(item)" class="side-nav-link-ref" routerLinkActive="active">
          <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
          <span class="text-white"> {{ item.label | translate }}</span>
          <span class="badge rounded-pill bg-{{item.badge.variant}} float-end" *ngIf="item.badge">{{item.badge.text |
            translate}}</span>
        </a>

        <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
          <li *ngFor="let subitem of item.subItems" >
            <a [routerLink]="subitem.link" *ngIf="!hasItems(subitem) && hasPermission(subitem)" class="side-nav-link-ref"
              [attr.data-parent]="subitem.parentId" routerLinkActive="active">
              {{ subitem.label | translate}}
            </a>
            <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow"
              [attr.data-parent]="subitem.parentId">
              {{ subitem.label | translate}}
            </a>
            <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
              <li *ngFor="let subSubitem of subitem.subItems">
                <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link" routerLinkActive="active"
                  class="side-nav-link-ref" *ngIf="hasPermission(subSubitem)">
                  {{ subSubitem.label | translate }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li> -->
    </div>

  </div>
</div>
<!-- Left Sidebar End -->
